

import { Grid, IconButton, InputAdornment } from '@material-ui/core'
import { Controller } from 'react-hook-form'
import * as Style from './styles'
import RegisterInput from 'components/RegisterInput'
import { Box } from '@mui/material'

import React, { memo, useState } from 'react'
import { Visibility, VisibilityOff } from '@material-ui/icons'
import { PasswordRequirementsList } from '../PasswordRequirementsList'
import { getPasswordStrength } from '../../../mocks'
import { PasswordStrengthBars } from '../PasswordStrengthBars'

function PasswordConfiguration({
    t,
    watch,
    errors,
    control,
    trigger,
}) {
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)

    return (
        <Style.Container
            container
            item
            xs={12}
            spacing={3}
            alignItems="flex-start"
        >
            <Grid item xs={12}>
                <Style.CustomTitle>
                    <Box component="b" textTransform="uppercase">{t('DEFINIÇÃO DE SENHA')}</Box>
                </Style.CustomTitle>
            </Grid>
            <Grid item container xs={12} md={4} alignItems="center" sx={{ marginTop: '0px' }}>
                <Controller
                    render={({ value, onChange }) => (
                        <Box width="100%">
                            <RegisterInput
                                onChange={(e) => {
                                    onChange(e)
                                    trigger('confirmPassword');
                                }}
                                value={value}
                                label={t('LOGIN_PASSWORD')}
                                error={!!errors.password}
                                style={{
                                    paddingTop: '0px',
                                    marginTop: '0px',
                                }}
                                type={showPassword ? 'text' : 'password'}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                disableRipple
                                                aria-label="toggle password visibility"
                                                onClick={() =>
                                                    setShowPassword(
                                                        !showPassword,
                                                    )
                                                }
                                            >
                                                {showPassword ? (
                                                    <Visibility />
                                                ) : (
                                                    <VisibilityOff />
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <PasswordStrengthBars strength={getPasswordStrength(watch('password'), watch())} />
                        </Box>

                    )}
                    name="password"
                    control={control}
                />
                <Controller
                    as={
                        <RegisterInput
                            label={t('CONFIRM_THE_PASSWORD')}
                            error={!!errors.confirmPassword}
                            helperText={t(errors?.confirmPassword?.message)}
                            type={showConfirmPassword ? 'text' : 'password'}
                            style={{ marginTop: '10px' }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            disableRipple
                                            aria-label="toggle password visibility"
                                            onClick={() =>
                                                setShowConfirmPassword(
                                                    !showConfirmPassword,
                                                )
                                            }
                                        >
                                            {showConfirmPassword ? (
                                                <Visibility />
                                            ) : (
                                                <VisibilityOff />
                                            )}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    }
                    name="confirmPassword"
                    control={control}
                />
            </Grid>
            <Grid item container xs={12} md={8}>
                <PasswordRequirementsList password={watch('password')} userData={watch()} />
            </Grid>
        </Style.Container>
    )
}

export default memo(PasswordConfiguration)

